/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { Container } from '../../../../styles/Grid';

import Spacer from '../../../ui/Spacer';
import DotComponent from '../../../ui/DotComponent';

import { SafePureComponent } from '../../../../utils/SafePureComponent';
import * as styles from './index.style';

export class Hero extends SafePureComponent {
  constructor(props) {
    super(props);
  }

  safeRender() {
    const { Title, Subtitle } = this.props;
    const title = Title.split('|');
    return (
      <Spacer customCss={styles.containerSizesShop}>
        <Container css={[styles.itemsContainerCss]}>
          <div className="c1shop">
            <h2>
              <span className="linebreak">{title[0]}</span>
              <span>{title[1]}</span>
              <DotComponent />
            </h2>
            <p>{Subtitle}</p>
          </div>
        </Container>
      </Spacer>
    );
  }
}

Hero.displayName = 'Shop/Hero';

export default withNamespaces()(Hero);
